import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import axios from "axios";
import { Modal } from "antd";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { currency, getStoreType } from "../../../../../dynamicController";
import { saveTransactionId, saveTransactionType } from "../../../../../redux/actions/paymentActions";

const STORETYPE = getStoreType()

const mySwal = withReactContent(Swal);

const PagBank = ({ token, saveTransactionId, saveTransactionType, theme }) => {

    const [paymentMethod, setPaymentMethod] = useState("DEEPLINK");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [taxId, setTaxId] = useState("");
    const [paymentAmount, setPaymentAmount] = useState("");
    const [loading, setLoading] = useState(false);
    const [pagbankPublicKey, setPagbankPublicKey] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [cardExpMonth, setCardExpMonth] = useState("");
    const [cardExpYear, setCardExpYear] = useState("");
    const [cardSecurityCode, setCardSecurityCode] = useState("");
    const [cardHolderName, setCardHolderName] = useState("");
    const [encryptedCard, setEncryptedCard] = useState(null);
    const [paymentConfirmationModal, setPaymentConfirmationModal] = useState(false);
    const [paymentConfirmationText, setPaymentConfirmationText] = useState("");

    const { t } = useTranslation();

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.country && location.state.description && location.state.paymentAmount) {
            if (location.state.user && location.state.user.name) {
                setUsername(location.state.user.name)
            }
            if (location.state.user && location.state.user.email) {
                setEmail(location.state.user.email)
            }
            if (location.state.user && location.state.user.taxId) {
                setTaxId(location.state.user.taxId)
            }
            if (location.state.paymentAmount) {
                setPaymentAmount(location.state.paymentAmount)
            }
            if (location.state.pagbankPublicKey) {
                setPagbankPublicKey(location.state.pagbankPublicKey)
            }
        } else {
            history.push("/")
        }

    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        const emailRegex = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/

        if (!username || !email || !taxId || !paymentMethod) {
            mySwal.fire(t("Error"), t("Please fill in all the required fields"), "error");
        } else if (email && !emailRegex.test(email)) {
            mySwal.fire(t("Error"), t("Invalid Email Address"), "error");
        } else if (taxId.length !== 11 && taxId.length !== 14) {
            mySwal.fire(t("Error"), t("11 digits for CPF or 14 digits for CNPJ"), "error");
        } else if (paymentMethod === "CREDIT_CARD" && (!cardNumber || !cardExpMonth || !cardExpYear || !cardSecurityCode || !cardHolderName)) {
            mySwal.fire(t("Error"), t("Please fill in your card details"), "error");
        } else {
            let card = null
            if (paymentMethod === "CREDIT_CARD") {
                card = window.PagSeguro.encryptCard({
                    publicKey: pagbankPublicKey,
                    holder: cardHolderName,
                    number: cardNumber,
                    expMonth: cardExpMonth,
                    expYear: cardExpYear,
                    securityCode: cardSecurityCode
                });

                setEncryptedCard(card)
            }

            if (card && (card.hasErrors || card.errors.length > 0 || !card.encryptedCard)) {
                if (card.errors[0]?.message) {
                    mySwal.fire(t("Error"), t(card.errors[0]?.message), "error");
                } else {
                    mySwal.fire(t("Error"), t("Some error happen with checking card information"), "error");
                }
            } else if (location.state.user && location.state.pkg && token) {
                // reload token
                setPaymentConfirmationText(<p className="text-center"><Trans i18nKey="Are you sure you want to purchase {{ tokenAmount }} e-Token for {{ currency }}{{ paymentAmount }}?">Are you sure you want to purchase {{ tokenAmount: location.state.pkg.token }} e-Token for {{ currency: currency(location.state.country) }}{{ paymentAmount: parseFloat(location.state.pkg.price).toFixed(2) }}?</Trans></p>)
                setPaymentConfirmationModal(true)
            } else if (location.state.endPoint && location.state.sendThis) {
                // machine payment / Drop n Go
                setPaymentConfirmationText(<p className="text-center">{t("Pay")} {currency(location.state.country)} {paymentAmount} {t("to")} {location.state.description}?</p>)
                setPaymentConfirmationModal(true)
            } else if (location.state.user && location.state.laundrypass && token) {
                // laundry pass purchase
                setPaymentConfirmationText(<p className="text-center">{t("Purchase")} {location.state.laundrypass.name} - {location.state.laundrypass.description} {t("for")} {currency(location.state.country)} {parseFloat(paymentAmount).toFixed(2)}?</p>)
                setPaymentConfirmationModal(true)
            }
        }
    }

    const confirmPayment = () => {
        setLoading(true)
        setPaymentConfirmationModal(false);
        if (location.state.user && location.state.pkg && token) {
            // reload token
            let sendThis = {
                userId: location.state.user.id,
                pkgId: location.state.pkg.id,
                type: "pagbank",
                paymentMethod,
                tax_id: taxId,
                email,
                username,
                card: encryptedCard ? encryptedCard.encryptedCard : null,
            }
            axios
                .post("/api/token/reload", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    saveTransactionType("Reload")
                    setLoading(false);
                    if (paymentMethod === "DEEPLINK") {
                        window.location.href = res.data.data.url;
                    } else if (paymentMethod === "PIX") {
                        history.push("/payment/qr", { url: res.data.data.url, text: res.data.data.text, transactionId: res.data.transactionId })
                    } else if (paymentMethod === "CREDIT_CARD") {
                        history.push("/thankyou")
                    }
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        } else if (location.state.endPoint && location.state.sendThis) {
            // machine payment / Drop n Go
            let sendThis = {
                ...location.state.sendThis,
                paymentMethod,
                taxId,
                email,
                username,
                card: encryptedCard ? encryptedCard.encryptedCard : null,
            }

            let headers = {
                "Content-Type": "application/json"
            }

            if (token) {
                headers = {
                    "Content-Type": "application/json",
                    "auth-token": token
                }
            }

            axios
                .post(location.state.endPoint, sendThis, { headers })
                .then(res => {
                    setLoading(false);
                    saveTransactionId(res.data.transactionId)
                    saveTransactionType("Transaction")
                    if (paymentMethod === "DEEPLINK") {
                        window.location.href = res.data.data;
                    } else if (paymentMethod === "PIX") {
                        history.push("/payment/qr", { url: res.data.data, text: res.data.text, transactionId: res.data.transactionId, kiosk: location.state.sendThis.kiosk, role: location.state.sendThis.role })
                    } else if (paymentMethod === "CREDIT_CARD") {
                        if (location.state.sendThis.kiosk) {
                            history.push("/kiosk")
                        } else if (location.state.sendThis.role === "staff") {
                            history.push("/staff")
                        } else {
                            history.push("/thankyou")
                        }
                    }
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        } else if (location.state.user && location.state.laundrypass && token) {
            // laundry pass purchase
            let sendThis = {
                userId: location.state.user.id,
                pkgId: location.state.laundrypass.id,
                paymentGateway: "pagbank",
                outletId: location.state.outletId,
                paymentMethod,
                tax_id: taxId,
                email,
                username,
                card: encryptedCard ? encryptedCard.encryptedCard : null,
            }

            axios
                .post("/api/subscription/purchase", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setLoading(false);
                    saveTransactionId(res.data.transactionId)
                    saveTransactionType("Subscription")
                    if (paymentMethod === "DEEPLINK") {
                        window.location.href = res.data.data.url;
                    } else if (paymentMethod === "PIX") {
                        history.push("/payment/qr", { url: res.data.data.url, text: res.data.data.text, transactionId: res.data.transactionId })
                    } else if (paymentMethod === "CREDIT_CARD") {
                        history.push("/thankyou")
                    }
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        }
    }

    return (
        <div id="setting-page" className="user-faq">
            <div id="setting-main">
                <div id="user-header">
                    <h5><i onClick={e => history.goBack()} className="bi bi-chevron-left me-3"></i> <strong>PagBank</strong></h5>
                </div>

                <div id="user-body" className="px-4">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group pt-3">
                            <h6>{t("Payment Amount")}</h6>
                            <p>{currency(location.state?.country)} {parseFloat(paymentAmount).toFixed(2)}</p>
                        </div>

                        <div className="form-group">
                            <h6>{t("Description")}</h6>
                            <p>{location.state.description}</p>
                        </div>

                        <div className="form-group">
                            <label htmlFor="username">{t("Name")}</label>
                            <input
                                type="text"
                                id="username"
                                name="username"
                                placeholder={t("Name")}
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">{t("Email")}</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder={t("Email")}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="taxId">{t("Tax ID (CPF/CNPJ Number)")}</label>
                            <input
                                type="number"
                                id="taxId"
                                name="taxId"
                                placeholder={t("Tax ID")}
                                value={taxId}
                                onChange={e => setTaxId(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <h6>{t("Payment Method")}</h6>
                            <label htmlFor="radio1">
                                <input type="radio" name="paymentMethod" id="radio1" value="DEEPLINK" className="with-gap" checked={paymentMethod === "DEEPLINK"} onChange={e => setPaymentMethod(e.target.value)} />
                                <span style={{ color: "black" }}>{t("PagBank App")}</span>
                            </label><br />

                            <label htmlFor="radio2">
                                <input type="radio" name="paymentMethod" id="radio2" value="PIX" className="with-gap" checked={paymentMethod === "PIX"} onChange={e => setPaymentMethod(e.target.value)} />
                                <span style={{ color: "black" }}>{t("PIX QR Code")}</span>
                            </label><br />

                            {
                                pagbankPublicKey ? (
                                    <label htmlFor="radio3">
                                        <input type="radio" name="paymentMethod" id="radio3" value="CREDIT_CARD" className="with-gap" checked={paymentMethod === "CREDIT_CARD"} onChange={e => setPaymentMethod(e.target.value)} />
                                        <span style={{ color: "black" }}>{t("Credit Card")}</span>
                                    </label>
                                ) : null
                            }
                        </div>

                        {
                            paymentMethod === "CREDIT_CARD" ? (
                                <div className="form-group">
                                    <label htmlFor="cardNumber">{t("Credit Card Number")}</label>
                                    <input
                                        type="number"
                                        id="cardNumber"
                                        name="cardNumber"
                                        placeholder={t("Credit Card Number")}
                                        value={cardNumber}
                                        onChange={e => setCardNumber(e.target.value)}
                                        required
                                    />
                                </div>
                            ) : null
                        }

                        {
                            paymentMethod === "CREDIT_CARD" ? (
                                <div className="form-group">
                                    <label htmlFor="cardExpMonth">{t("Credit Card Expiry Month")}</label>
                                    <input
                                        type="number"
                                        id="cardExpMonth"
                                        name="cardExpMonth"
                                        placeholder={t("Credit Card Expiry Month")}
                                        value={cardExpMonth}
                                        onChange={e => setCardExpMonth(e.target.value)}
                                        required
                                        min={1}
                                        max={12}
                                    />
                                </div>
                            ) : null
                        }

                        {
                            paymentMethod === "CREDIT_CARD" ? (
                                <div className="form-group">
                                    <label htmlFor="cardExpYear">{t("Credit Card Expiry Year")}</label>
                                    <input
                                        type="number"
                                        id="cardExpYear"
                                        name="cardExpYear"
                                        placeholder={t("Credit Card Expiry Year")}
                                        value={cardExpYear}
                                        onChange={e => setCardExpYear(e.target.value)}
                                        required
                                    />
                                </div>
                            ) : null
                        }

                        {
                            paymentMethod === "CREDIT_CARD" ? (
                                <div className="form-group">
                                    <label htmlFor="cardSecurityCode">{t("Credit Card Securtiy Code")}</label>
                                    <input
                                        type="number"
                                        id="cardSecurityCode"
                                        name="cardSecurityCode"
                                        placeholder={t("Credit Card Securtiy Code")}
                                        value={cardSecurityCode}
                                        onChange={e => setCardSecurityCode(e.target.value)}
                                        required
                                    />
                                </div>
                            ) : null
                        }

                        {
                            paymentMethod === "CREDIT_CARD" ? (
                                <div className="form-group">
                                    <label htmlFor="cardHolderName">{t("Credit Card Holder Name")}</label>
                                    <input
                                        type="text"
                                        id="cardHolderName"
                                        name="cardHolderName"
                                        placeholder={t("Credit Card Holder Name")}
                                        value={cardHolderName}
                                        onChange={e => setCardHolderName(e.target.value)}
                                        required
                                    />
                                </div>
                            ) : null
                        }

                        {
                            loading ? (
                                <div className="text-center">
                                    <div className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"} role="status">
                                        <span className="sr-only">Loading ...</span>
                                    </div>
                                </div>
                            ) : (
                                <input
                                    id="pagbank-payment"
                                    type="submit"
                                    value={t("Pay")}
                                    className="btn big-button form-control"
                                />
                            )
                        }
                    </form>
                </div>
            </div>

            <Modal
                open={paymentConfirmationModal}
                onCancel={(e) => setPaymentConfirmationModal(false)}
                footer={null}
                closable={true}
                centered
            >
                <div className={theme}>
                    <div className="text-center">
                        <i className="bi bi-question-circle" style={{ color: "#87adbd", fontSize: "70px" }}></i>
                    </div>
                    <h2 className="text-center pb-2">{t("Confirmation")}</h2>
                    {paymentConfirmationText ? <div>{paymentConfirmationText}</div> : null}
                    <div className={`d-flex pt-3 justify-content-center ${STORETYPE === "cleanpro" ? "flex-row-reverse" : ""}`}>
                        {
                            loading ? (
                                <div className="text-center">
                                    <div
                                        className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`}
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-primary cleanpro-swal-btn washup-swal-btn mx-1"
                                        style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
                                        onClick={(e) => confirmPayment()}
                                    >
                                        {t("Yes")}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-secondary cleanpro-swal-secondary-btn washup-swal-btn mx-1"
                                        onClick={(e) => setPaymentConfirmationModal(false)}
                                    >
                                        {t("No")}
                                    </button>
                                </>
                            )
                        }
                    </div>
                </div>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.user.token,
        theme: state.theme.theme,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveTransactionId: (data) => dispatch(saveTransactionId(data)),
        saveTransactionType: (data) => dispatch(saveTransactionType(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PagBank);